// <template>
// </template>
// <script>
import {setTitle} from 'com/js/common'
module.exports = {
    // 左侧引导文本 左侧连接 标题 右侧文本  右侧连接
    //type默认不写则不显示  1.文字，2.分享，3.二维码，等等
    props: ['left_text', 'left_href',  'title', 'right_text', 'right_href','type'],
    created(){
      if(this.title)    setTitle(this.title)
    },
    ready(){
        if(this.title)    setTitle(this.title)
    }
}
// </script>
//
//
/* generated by vue-loader */



// WEBPACK FOOTER //
// ./src/component/near_powerstation/header.vue